exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-study__video{width:100%;font-size:30px;display:block;position:relative;background-color:#03162a;z-index:1}.case-study__video-row{width:100%;padding:5em;margin-top:4em;margin-bottom:5em;background-color:#03162a;margin-left:50%;transform:translateX(-50%)}.case-study__video-half-row{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center}.case-study__video-half{width:40%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5561e39a!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/CaseStudy/CaseStudyVideo.vue
// module id = 119
// module chunks = 0